// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns
import { gql } from '@apollo/client';
import { isEmpty } from 'lodash';

import { useLazyQuery } from '@ion/api';
import permissions from '@ion/api/Apollo/permissions';

export const query = gql`
  query PipelineIDs(
    $clusterIdFilter: pipelines_bool_exp!
    $integrationIdFilter: pipelines_bool_exp!
    $playbookIdFilter: pipelines_bool_exp!
    $tagIdFilter: pipelines_bool_exp!
    $searchTerm: String!
  ) {
    pipelines(
      where: {
        _and: [
          { deletedAt: { _is_null: true } }
          $clusterIdFilter
          $integrationIdFilter
          $playbookIdFilter
          $tagIdFilter
          { _or: [{ name: { _ilike: $searchTerm } }, { writekey: { _ilike: $searchTerm } }] }
        ]
      }
    ) {
      id
    }
  }
`;

export function buildVariables({ clusterIds, integrationId, playbookId, tagIds, searchTerm }) {
  const clusterIdFilter = !isEmpty(clusterIds) ? { clusterId: { _in: clusterIds } } : {};
  const integrationIdFilter = !isEmpty(integrationId)
    ? { pipeline_integrations: { integration: { id: { _eq: integrationId } } } }
    : {};
  const playbookIdFilter = !isEmpty(playbookId)
    ? { pipeline_integrations: { staged_revision: { playbook: { id: { _eq: playbookId } } } } }
    : {};
  const tagIdFilter = !isEmpty(tagIds) ? { pipeline_tags: { tagId: { _in: tagIds } } } : {};

  return {
    searchTerm: `%${searchTerm}%`,
    clusterIdFilter,
    integrationIdFilter,
    playbookIdFilter,
    tagIdFilter,
  };
}

export default function useLazyQueryPipelineIds({ ...options } = {}) {
  const [executeQuery, { data, ...rest }] = useLazyQuery(query, {
    context: { permission: permissions.readPipeline },
    fetchPolicy: 'network-only',
    ...options,
  });

  const getPipelineIds = ({ clusterIds, integrationId, playbookId, tagIds, searchTerm }) => {
    const variables = buildVariables({ clusterIds, integrationId, playbookId, tagIds, searchTerm });
    return executeQuery({ variables });
  };

  return [getPipelineIds, { data: data?.pipelines, ...rest }];
}
